export const EN_US: Readonly<any> = {
  ID: 'en-us',
  STRINGS: {},
};
